import { NominationPartnerType } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateNominationPartnerTypes: (
  fetchContext: FetchContext,
  nominationId: number,
  partnerTypes: NominationPartnerType[],
  accessToken?: string,
) => Promise<void> = (fetchContext, nominationId, partnerTypes, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/nominations/${nominationId}/partnertypes`, {
    method: 'PUT',
    body: JSON.stringify(partnerTypes),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update nomination partner types'));
